const newModel = () => {
    return {
        monHocId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

const newFEModel = () => {
    return {
        monHocId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        monHocId: item.monHocId,
        ten: item.ten,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        monHocId: item.monHocId,
        ten: item.ten,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        monHocId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        monHocId: item.monHocId,
        ten: item.ten,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        monHocId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null
    }
}

export const monHocGDModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


